<template>
  <div style="background: #fff">
    <div
      class="home-top"
      :style="{
        background: 'url(' + img + ') no-repeat',
      }"
    >
      <div class="navBar">
        <img src="../assets/ic_fanhui@2x.png" alt="" />
        <p>{{ name }}</p>
      </div>
      <div class="top-yield">
        <transition name="slide-fade">
          <div class="left-pop" v-show="show">
            <div class="left-pop-main">
              <img class="jiantou" src="../assets/xiaosanjiao@2x.png" alt="" />
              <div>
                <span
                  >初始资金（{{ (info.initMoney / 10000).toFixed(2) }}万）</span
                ><img
                  class="guanbi"
                  @click="show = false"
                  src="../assets/guanbi.png"
                  alt=""
                />
              </div>
            </div>
          </div>
        </transition>
        <div class="top-yield1">
          <div class="left">
            <div class="left-top">
              <span>总资产</span>
              <img
                class="wenhao"
                @click="showClick()"
                src="../assets/ic_yiwen@2x.png"
                alt=""
              />
            </div>
            <div class="num">{{ info.totalAssets }}</div>
            <div>
              <span style="padding-right: 0.15rem">总盈亏</span
              ><span style="padding-right: 0.02rem"
                >{{ info.totalProfit }}
              </span>
              ({{ info.totalProfitRate }})
            </div>
          </div>
          <div class="right" @click="goCzfx()">
            <img src="../assets/ic_czfx@2x.png" alt="" />
            <span>操作分析</span>
          </div>
        </div>
        <div class="top-yield2">
          <ul>
            <li>
              <p class="title">持仓市值</p>
              <p class="num">{{ info.sharesValue }}</p>
            </li>
            <li>
              <p class="title">可用资金</p>
              <p class="num">{{ info.balance }}</p>
            </li>
            <li>
              <p class="title">今日盈亏({{ info.todayProfitRate }})</p>
              <p class="num">{{ info.todayProfit }}</p>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="IconList">
      <ul>
        <li
          v-for="(item, index) in list"
          :key="index"
          @click="godetali(item.path)"
        >
          <img :src="item.img" alt="" />
          <p>{{ item.name }}</p>
        </li>
      </ul>
    </div>
    <div class="grid-stock">
      <div class="todaySelected-top">
        <div style="padding-left: 0.32rem">当前持仓</div>
      </div>
      <div style="margin-top: 0.1rem">
        <div class="main-centent">
          <div class="todaySelected-title">
            <div style="width: 2.08rem">股票/市值</div>
            <div style="width: 1.8rem">现价/成本</div>
            <div style="width: 1.3rem">持仓/可卖</div>
            <div style="width: 1.65rem; text-align: right">
              <span>盈亏</span>
            </div>
          </div>
        </div>
        <div v-if="stockList.length > 0">
          <Chicang :list="stockList"></Chicang>
        </div>
        <div v-else class="wushuju" v-show="stockShow">
          <img src="../assets/wushuju.png" alt="" />
          <p>暂无数据</p>
        </div>
      </div>
    </div>
    <ul class="list">
      <li @click="goJYGZ()">
        <span>交易规则</span><img src="../assets/more.png" alt="" />
      </li>
      <li @click="resetClick()">
        <span>重置账户</span><img src="../assets/more.png" alt="" />
      </li>
    </ul>
    <div>
      <div class="add" @click.stop="goxzbj()">
        <img src="../assets/ic_xiebiji@2x.png" alt="" /><span>笔记</span>
      </div>
    </div>
  </div>
</template>

<script>
import Chicang from "@/components/chicang.vue";
import api from "@/api/index";
import { arc4, Base64 } from "@/utils/arc4";
import { Dialog, Toast } from "vant";
export default {
  components: { Chicang, [Toast.name]: Toast },
  data() {
    return {
      img: require("../assets/bg_mnjy_zhang@2x.png"),
      list: [
        {
          name: "买入",
          img: require("../assets/ic_mairu@2x.png"),
          path: "/deal?id=0",
        },
        {
          name: "卖出",
          img: require("../assets/ic_maichu@2x.png"),
          path: "/deal?id=1",
        },
        {
          name: "查询",
          img: require("../assets/ic_chaxun@2x.png"),
          path: "/deal?id=2",
        },
        {
          name: "策略笔记",
          img: require("../assets/ic_celuebiji@2x.png"),
          path: "/clbj",
        },
      ],
      info: {},
      stockList: [],
      show: false,
      userId: "",
      sign: "",
      webkey: "",
      stockShow: false,
      name: "",
    };
  },
  created() {
    this.sign = this.$route.query.sign;
    if (this.sign) {
      var b = new Base64();
      var text = b.decode(this.sign);
      text = arc4(text, "yourui2019");
      console.log(text);
      this.webkey = text.split("appkey=")[1].split("&")[0];
      this.name = text.split("name=")[1].split("&")[0];
      document.title = this.name;
      localStorage.setItem("webkey", this.webkey);
      this.getCreate();
    }else{
      this.userId = this.$route.query.accountId;
       this.webkey = this.$route.query.webkey;
        this.name = this.$route.query.name;
      document.title = this.name;
        localStorage.setItem("userId", this.userId);
        localStorage.setItem("webkey", this.webkey);
        this.getFund();
          this.getlist();
    }
  },

  watch: {
    stockList() {
      this.timer();
    },
  },
  destroyed() {
    clearTimeout(this.timer);
  },

  methods: {
    goJYGZ() {
      this.$router.push({ path: "/jygz" });
    },
    resetClick() {
      Dialog.confirm({
        title: "重置账户",
        message:
          "重置账户后，模拟账户本金重置为初始模拟资金，且账户所有的盈利和亏损都将清零。",
      })
        .then(() => {
          api.getClear({ accountId: this.userId }).then((res) => {
            // console.log(res);
            if (res.code == 200) {
              Toast("重置成功");
              this.getFund();
              this.getlist();
            }
          });
        })
        .catch(() => {
          // on cancel
          // console.log(222);
        });
    },
    getCreate() {
      let params = {
        sign: this.sign,
      };
      api.getCreate(params).then((res) => {
        // console.log(res);
        if (res.code == 200) {
          this.userId = res.data.accountId;
          localStorage.setItem("userId", res.data.accountId);

          this.getFund();
          this.getlist();
        } else {
        }
      });
    },
    showClick() {
      if (this.show == false) {
        this.show = true;
      } else {
        this.show = false;
      }
    },
    timer() {
      return setTimeout(() => {
        this.getFund();
        this.getlist();
      }, 3000);
    },
    goxzbj() {
      this.$router.push({ path: "/xzbj" });
    },
    goCzfx() {
      this.$router.push({ path: "/czfx" });
    },
    godetali(path) {
      this.$router.push({ path: path });
    },
    getFund() {
      api.getFund({ analog_stock_account_id: this.userId }).then((res) => {
        // console.log(res);
        if (res.code == 200) {
          res.data.todalProfit = (
            Number(res.data.sharesValue) +
            Number(res.data.frozenMoney) +
            Number(res.data.balance) -
            Number(res.data.initMoney)
          ).toFixed(2);
          // console.log(totalProfit);
          res.data.totayProfit = (
            Number(res.data.totalAssets) - Number(res.data.yestodayTotalAsserts)
          ).toFixed(2);
          this.info = res.data;
          if (res.data.totalProfit >= 0) {
            this.img = require("../assets/bg_mnjy_zhang@2x.png");
          } else {
            this.img = require("../assets/bg_mnjy_die@2x.png");
          }
        }
      });
    },
    getlist() {
      api
        .getStockShares({ analog_stock_account_id: this.userId })
        .then((res) => {
          // console.log(res);
          if (res.code == 200) {
            this.stockList = res.data;
            if (this.stockList.length > 0) {
              this.stockShow = false;
            } else {
              this.stockShow = true;
            }
          }
        });
    },
  },
};
</script>

<style lang="less" scoped>
.slide-fade-enter-active {
  transition: all 0.8s ease;
}
.slide-fade-leave-active {
  transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active 用于 2.1.8 以下版本 */ {
  transform: translateX(-20px);
  opacity: 0;
}
.home-top {
  width: 100%;
  height: 4.8rem;
  background-size: 100% 4.8rem !important;
  .navBar {
    height: 0.88rem;
    display: flex;
    align-items: center;
    position: relative;
    img {
      width: 0.44rem;
      height: 0.44rem;
      padding: 0.22rem 0.3rem;
    }
    p {
      position: absolute;
      color: #fff;
      width: 100%;
      text-align: center;
      font-size: 0.36rem;
      font-weight: bold;
    }
  }

  .left-pop {
    position: absolute;
    left: 1.6rem;
    top: 0.3rem;
    .left-pop-main {
      height: 0.78rem;
      font-size: 0.28rem;
      color: #666666;
      display: flex;
      justify-content: space-between;
      align-items: center;
      div {
        padding: 0 0.22rem;
        height: 100%;
        border: 0.01rem solid #fff;
        background: #fff;
        display: flex;
        justify-content: space-between;
        align-items: center;
        border-radius: 0.08rem;
        margin-left: 0.14rem;
      }
      .jiantou {
        width: 0.15rem;
        border: 0;
        position: absolute;
      }
      span {
        padding-left: 0.14rem;
      }
      .guanbi {
        width: 0.32rem;
        // margin-left: 0.3rem;
      }
    }
  }
  .top-yield {
    height: 3.92rem;
    position: relative;
    .top-yield1 {
      height: 2.76rem;
      color: #fff;
      display: flex;
      justify-content: space-between;
      .left {
        padding-left: 0.32rem;
        .left-top {
          margin-top: 0.42rem;
          display: flex;
          align-items: center;
          font-size: 0.24rem;
          height: 0.34rem;
          font-weight: 500;
          .wenhao {
            width: 0.3rem;
            padding-left: 0.08rem;
          }
        }
        .num {
          height: 0.88rem;
          font-size: 0.72rem;
          font-family: Arial, Helvetica, sans-serif;
          color: #ffffff;
          line-height: 0.88rem;
        }
        div {
          font-size: 0.24rem;
          height: 0.34rem;
          padding-top: 0.1rem;
        }
      }
      .right {
        width: 2.08rem;
        height: 1rem;
        background: url(../assets/bg_czfx@2x.png) no-repeat;
        background-size: 100% 100%;
        margin-top: 0.78rem;
        display: flex;
        align-items: center;
        img {
          width: 0.28rem;
          margin: 0 0.16rem 0 0.44rem;
        }

        font-size: 0.24rem;
        font-weight: 500;

        line-height: 0.34rem;
      }
    }
    .top-yield2 {
      height: 1.14rem;
      border-top: 0.01rem solid rgba(255, 255, 255, 0.2);
      ul {
        width: 100%;
        display: flex;
        height: 1.14rem;
        li {
          width: 2.49rem;
          height: 1.14rem;
          color: #fff;
          p {
            padding-left: 0.32rem;
          }
          .title {
            color: rgba(255, 255, 255, 0.6);
            margin: 0.2rem 0 0.04rem 0;
            font-size: 0.24rem;
            font-weight: 500;
            line-height: 0.34rem;
          }
          .num {
            height: 0.38rem;
            font-size: 0.32rem;
            font-family: Arial, Helvetica, sans-serif;
            line-height: 0.38rem;
          }
        }
        li:nth-child(2) {
          border-right: 0.01rem solid rgba(255, 255, 255, 0.2);
          border-left: 0.01rem solid rgba(255, 255, 255, 0.2);
        }
      }
    }
  }
}
.IconList {
  height: 1.92rem;
  ul {
    width: 100%;
    padding-top: 0.4rem;
    display: flex;
    justify-content: space-around;
    li {
      width: 1.2rem;
      display: flex;
      flex-direction: column;
      align-items: center;
      img {
        width: 0.44rem;
        height: 0.44rem;
        margin-bottom: 0.2rem;
      }
      p {
        text-align: center;
      }
    }
  }
  /deep/.van-grid-item__content {
    position: relative;
  }
}
.add {
  position: fixed;
  right: 0;
  bottom: 0.8rem;
  width: 1.12rem;
  height: 0.8rem;
  background: #ffffff;
  box-shadow: 0px 0.08rem 0.2rem 0px rgba(0, 0, 0, 0.14);
  border-radius: 2rem 0px 0px 2rem;
  padding: 0 0.4rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  img {
    width: 0.34rem;
    height: 0.34rem;
  }
  span {
    font-size: 0.32rem;
    font-weight: 500;
    color: #ec333b;
    line-height: 0.44rem;
  }
}
.main-centent {
  padding: 0 0 0 0.32rem;
  // border-bottom: 0.01rem solid rgba(237, 237, 237, 1);
}
.todaySelected-top {
  height: 0.5rem;
  font-size: 0.36rem;
  font-weight: bold;
  color: #333333;
  line-height: 0.5rem;
}
.todaySelected-title {
  height: 0.76rem;
  color: #666666;
  //   margin: 0 0 0 0.32rem;
  font-size: 0.24rem;

  display: flex;
  justify-content: initial;
  align-items: center;

  div:nth-child(4) {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    img {
      width: 0.44rem;
      height: 0.44rem;
    }
  }
}
.wushuju {
  height: 3rem;
  background: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  // padding-top: 0.2rem;
  img {
    height: 2.5rem;
    width: 2.5rem;
  }
}
.list {
  border-top: 0.16rem solid rgba(237, 237, 237, 0.8);
  li {
    height: 1rem;
    background: #fff;
    padding: 0 0.32rem;
    font-size: 0.32rem;
    font-weight: 500;
    color: #333333;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 0.02rem solid rgba(237, 237, 237, 0.8);
    img {
      width: 0.48rem;
      height: 0.48rem;
    }
  }
  li:nth-child(2) {
    border-bottom: 0.2rem solid rgba(245, 245, 245, 1);
  }
}
</style>